import { UserActiveFilter } from './../../common/enums';
export class UserFilterSettingsModel {
  public name: string;
  public email: string;
  public roleId: number;
  public regionId: number;
  public actives: UserActiveFilter;
}